import { createDeck, shuffle, sortHand } from './tiles.js';
import { DEFAULT_PLAYERS, HUMAN_INDEX } from './constants.js';

// Build the initial game state, post-deal, pre-Charleston. The dealer (East)
// gets the 14th tile; everyone else has 13. `dealerIndex` is the engine
// index of the dealer — defaults to 1 to match the original monolith's
// player layout [human(South)=0, East=1, North=2, West=3]. For online mode
// the lobby passes [East=0, South=1, West=2, North=3] with dealerIndex=0 so
// the (i+1)%4 advance yields canonical NMJL turn order.
export function newGameState({
  seed,
  rng,
  players = DEFAULT_PLAYERS,
  difficulty = 'beginner',
  dealerIndex = 1,
  sortHandIndex = HUMAN_INDEX,
}) {
  const wall = shuffle(createDeck(), rng);
  const state = {
    difficulty,
    seed,
    wall,
    players: players.map((p) => ({
      name: p.name,
      seat: p.seat,
      isAI: !!p.isAI,
      hand: [],
      exposed: [],
    })),
    discards: [],
    currentPlayer: dealerIndex,
    phase: 'charleston',
    charStep: 0,
    hasDrawn: false,
    lastDiscard: null,
    winner: null,
  };

  for (let i = 0; i < 13; i++) {
    for (let p = 0; p < state.players.length; p++) {
      state.players[p].hand.push(state.wall.pop());
    }
  }
  state.players[dealerIndex].hand.push(state.wall.pop());

  if (sortHandIndex != null && state.players[sortHandIndex]) {
    sortHand(state.players[sortHandIndex].hand);
  }
  return state;
}
